<div
  [class.outro]="isJobStatusComplete"
  class="canvas animate-restore"
  [class.canvas-hide]="hideCanvas"
>
  <div class="viewport">
    <div class="star-layer">
      <div class="star star1"></div>
      <div class="star star2"></div>
      <div class="star star3"></div>
      <div class="star shooting-star"></div>
    </div>
    <div class="outro-right">
      <div class="cloud2">
        <div class="inner-cloud">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 110">
            <path
              class="svg-cloud"
              d="M173 56.1h-6c0-19.1-15.5-34.6-34.7-34.6 -6.6 0-12.8 1.8-18 5C107.8 11 92.5 0 74.5 0c-23.7 0-43 19.2-43 42.8 0 1 0 1.9 0.1 2.8C14.1 46 0 60.3 0 77.8c0 16 11.7 29.2 27 31.7v0.4H173c14.9 0 27-12.1 27-26.9C200 68.2 187.9 56.1 173 56.1z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="outro-left">
      <div class="cloud">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 110">
          <path
            class="svg-cloud"
            d="M173 56.1h-6c0-19.1-15.5-34.6-34.7-34.6 -6.6 0-12.8 1.8-18 5C107.8 11 92.5 0 74.5 0c-23.7 0-43 19.2-43 42.8 0 1 0 1.9 0.1 2.8C14.1 46 0 60.3 0 77.8c0 16 11.7 29.2 27 31.7v0.4H173c14.9 0 27-12.1 27-26.9C200 68.2 187.9 56.1 173 56.1z"
          />
        </svg>
        <div class="house">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="house-svg"
            viewBox="0 0 75 69.7"
          >
            <style type="text/css">
              .st0 {
                fill: #b39ddb;
              }

              .st1 {
                fill: #6a1b9a;
              }

              .st2 {
                fill: #9575cd;
              }

              .st3 {
                fill: #d1c4e9;
              }
            </style>
            <g class="house-part house-main">
              <polygon
                class="wall st0"
                points="74 31.2 38.1 2.2 1.1 32.4 4.6 32.4 4.6 67.6 70.4 67.6 70.4 31.3"
              />
              <polygon
                class="roof st1"
                points="2.1 33.7 0 31.1 38.1 0 75.1 29.9 72.9 32.5 38.1 4.3"
              />
            </g>
            <g class="house-part window-part">
              <polygon
                class="roof-window st1"
                points="44.1 40.4 42 37.8 57.4 25.3 72.7 37.7 70.6 40.3 57.4 29.6"
              />
              <polygon
                class="window st2"
                points="57.4 34.6 51.1 39.6 51.1 57.8 63.6 57.8 63.6 39.6"
              />
            </g>
            <g class="house-part door-part">
              <polygon
                class="wall-door st3"
                points="51.6 32.2 26.4 12 1.1 32.4 8.5 32.4 8.5 69.7 44.1 69.7 44.1 32.2"
              />
              <polygon
                class="roof-door st1"
                points="2.1 33.7 0 31.1 26.4 9.8 52.6 30.8 50.5 33.5 26.4 14.2"
              />
              <path
                class="door st2"
                d="M26.4 20.2L12.3 31.6l28-0.2L26.4 20.2zM18.5 69.7h15.7V37.4H18.5V69.7z"
              />
            </g>
          </svg>
        </div>
        <div class="inner-cloud inner-cloud-left">
          <div class="cloud-background">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 110">
              <path
                class="svg-cloud"
                d="M173 56.1h-6c0-19.1-15.5-34.6-34.7-34.6 -6.6 0-12.8 1.8-18 5C107.8 11 92.5 0 74.5 0c-23.7 0-43 19.2-43 42.8 0 1 0 1.9 0.1 2.8C14.1 46 0 60.3 0 77.8c0 16 11.7 29.2 27 31.7v0.4H173c14.9 0 27-12.1 27-26.9C200 68.2 187.9 56.1 173 56.1z"
              />
            </svg>
          </div>
          <div class="cloud-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 110">
              <path
                class="svg-cloud"
                d="M173 56.1h-6c0-19.1-15.5-34.6-34.7-34.6 -6.6 0-12.8 1.8-18 5C107.8 11 92.5 0 74.5 0c-23.7 0-43 19.2-43 42.8 0 1 0 1.9 0.1 2.8C14.1 46 0 60.3 0 77.8c0 16 11.7 29.2 27 31.7v0.4H173c14.9 0 27-12.1 27-26.9C200 68.2 187.9 56.1 173 56.1z"
              />
            </svg>
          </div>
        </div>
        <div class="inner-cloud inner-cloud-right">
          <div class="cloud-background">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 110">
              <path
                class="svg-cloud"
                d="M173 56.1h-6c0-19.1-15.5-34.6-34.7-34.6 -6.6 0-12.8 1.8-18 5C107.8 11 92.5 0 74.5 0c-23.7 0-43 19.2-43 42.8 0 1 0 1.9 0.1 2.8C14.1 46 0 60.3 0 77.8c0 16 11.7 29.2 27 31.7v0.4H173c14.9 0 27-12.1 27-26.9C200 68.2 187.9 56.1 173 56.1z"
              />
            </svg>
          </div>
          <div class="cloud-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 110">
              <path
                class="svg-cloud"
                d="M173 56.1h-6c0-19.1-15.5-34.6-34.7-34.6 -6.6 0-12.8 1.8-18 5C107.8 11 92.5 0 74.5 0c-23.7 0-43 19.2-43 42.8 0 1 0 1.9 0.1 2.8C14.1 46 0 60.3 0 77.8c0 16 11.7 29.2 27 31.7v0.4H173c14.9 0 27-12.1 27-26.9C200 68.2 187.9 56.1 173 56.1z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="texts">
    <div class="text text1">
      Sunsetting the current version
      <span>Please wait...</span>
    </div>
    <div class="text text2">
      Doing some magic
      <span>Please wait...</span>
    </div>
    <div class="text text3">
      Loading the selected backup
      <span>Please wait...</span>
    </div>
    <div class="text text-end">
      <strong>Site successfully restored!</strong>
    </div>
  </div>
</div>
